export default __webpack_public_path__ + "static/media/frame2.7a98db74.png";